import React from "react";
import { Navigate } from "react-router-dom";
import {jwtDecode} from "jwt-decode";

const RequireGuest = ({ children }) => {
  const accessToken = localStorage.getItem("access_token");

  const isTokenValid = (token) => {
    try {
      const { exp } = jwtDecode(token); // Decode the token to extract the expiration time
      return exp * 1000 > Date.now(); // Check if the token is still valid
    } catch (error) {
      console.error("Error decoding token:", error);
      return false;
    }
  };

  // Redirect to dashboard if the user is logged in and the token is valid
  if (accessToken && isTokenValid(accessToken)) {
    return <Navigate to={"/dashboard"} />;
  }

  // Allow access to children (e.g., Register or VerifyOtp) if not logged in
  return children;
};

export default RequireGuest;
